import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { downloadExportResultFailed, downloadExportResultSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';

export default function* downloadExportResult(action) {
  try {
    const url = `${BACKEND_URL_V2}/export-tasks/${action.payload}/download `;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      yield put(downloadExportResultSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield dataResponse.json();
      yield put(downloadExportResultFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(downloadExportResultFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
